export const moduleId = 'redSaleReimbursement';
export const state = {
    lists: {},//orglist
    detailsDisplay: false,//详情显示隐藏
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    id: '',
    isDeapproval: false,
    isRouter: false,
    routeSource: false,
    isAdd: true,
    abId: '',
    orderNo: '',//发货/发票单号
}
export const mutations = {
    setRedSaleIsAdd(state, flag) {
        state.isAdd = flag
    },
    //反审批
    setRedSaleIsDeapproval(state, data) {
        state.isDeapproval = data
    },
    setRedSaleRouteSource(state, data) {
        state.routeSource = data
    },
    setRedDetailsDisplay(state, data) {
        state.detailsDisplay = data
    },
    setRedSaleDialogzt(state, data) {
        state.dialogzt = data
    },
    setRedSaleOrgList(state, data) {
        state.lists = data
    },
    setRedSaleFalg(state, data) {
        state.flag = data
    },
    setRedSaleIsRouter(state, data) {
        state.isRouter = data
    },
    setRedSaleOrderNo(state, data) {
        state.orderNo = data
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/red-sale-reimbursement/index.js